import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Page data cache keyed by URL, used only when arriving via Back/Forward so lists reappear exactly as left.
const cache = new Map();
export const clearRestoreCache = () => cache.clear();
const MAX = 12;

export function useRestored() {
  const { pathname, search } = useLocation();
  const type = useNavigationType();
  const key = pathname + search;
  const restored = useRef(type === "POP" ? cache.get(key) : undefined).current;
  const remember = (data) => {
    cache.delete(key);
    cache.set(key, data);
    if (cache.size > MAX) cache.delete(cache.keys().next().value);
  };
  return [restored, remember];
}

// Window scroll restoration: save on leave, restore on Back/Forward (waits for content to grow), top on new pages.
const positions = new Map();
export function useScrollRestore() {
  const { key } = useLocation();
  const type = useNavigationType();
  useEffect(() => {
    let frame;
    if (type === "POP") {
      const y = positions.get(key) || 0;
      let tries = 0;
      const attempt = () => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max >= y || tries++ > 90) window.scrollTo(0, Math.min(y, Math.max(max, 0)));
        else frame = requestAnimationFrame(attempt);
      };
      attempt();
    } else window.scrollTo(0, 0);
    return () => { cancelAnimationFrame(frame); positions.set(key, window.scrollY); };
  }, [key, type]);
}
